import { render, staticRenderFns } from "./RepresentativePersonRules.vue?vue&type=template&id=17898d39&scoped=true&"
import script from "./RepresentativePersonRules.vue?vue&type=script&lang=js&"
export * from "./RepresentativePersonRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17898d39",
  null
  
)

export default component.exports